import styles from "./option-card.module.scss";

interface IProps {
  title: string;
  description?: string;
  selected: boolean;
  onClick: () => void;
}

// A card that behaves like a radio option, for choices that need a word of explanation.
const OptionCard = (props: IProps) => {
  const { title, description, selected, onClick } = props;

  return (
    <button
      type="button"
      role="radio"
      aria-checked={selected}
      className={`${styles.optionCard} ${selected ? styles.selected : ""}`}
      onClick={onClick}
    >
      <div className="text-dark font-size-13 font-weight-600">{title}</div>
      {description && (
        <div className="text-light font-size-11 mt-2">{description}</div>
      )}
    </button>
  );
};

export default OptionCard;
